import { spawn } from 'redux-saga/effects';

import { watchGetCoverPreview } from './preview';

export default function* saga() {
  yield spawn(watchGetCoverPreview);
}
